export interface WhiteboardSpeechObservation {
  id?: unknown;
  text?: unknown;
  firstReceivedTime?: unknown;
  mergedTranscriptIds?: unknown;
}

export function getWhiteboardSpeechObservationId(speech: WhiteboardSpeechObservation): string {
  if (Array.isArray(speech.mergedTranscriptIds)) {
    const segmentIds = speech.mergedTranscriptIds
      .map((segmentId) => String(segmentId || "").trim())
      .filter(Boolean);
    if (segmentIds.length > 0) {
      return Array.from(new Set(segmentIds)).join("+");
    }
  }

  return String(
    speech.id || `${speech.firstReceivedTime || "speech"}:${String(speech.text || "")}`
  );
}
